
import { Select, SelectProps } from 'antd'
import React from 'react'
import { FilterSelectPc } from '../FilterSelect/FilterSelectPc';
import { useSearchConditionPc } from '../hooks/useSearchCondition';


export interface FilterGoodsTypePcProps extends SelectProps{

}
const FilterGoodsTypePc = (props:FilterGoodsTypePcProps) =>{
    const { value , placeholder='商品标识', ...rest } = props
    const { searchCondition, loading, getInitData } = useSearchConditionPc({ goods: ['goods_type'] })
    return (
        <FilterSelectPc
            allowClear
            dropdownStyle={{ maxHeight: 400,  overflow: "auto" }}
            style={{width:'100%'}}
            value={value}
            placeholder={placeholder}
            options={searchCondition.goods?.goods_type}
            loading={loading}
            getInitData={getInitData}
            {...rest}
        />
    )
}
export default FilterGoodsTypePc